import request from '@/utils/request';
import {loginOrg} from '@/utils/LoginContext';

export async function query(payload) {
  return request(`/iwms-wms/wms/inner/consuming/page`, {
    method: 'POST',
    body: payload
  });
}

export async function get(payload) {
  return request(`/iwms-wms/wms/inner/consuming/${payload.uuid}`);
}

export async function getForRtn(payload) {
  return request(`/iwms-wms/wms/inner/consuming/${payload.uuid}/forRtn`);
}

export async function getByBillNumber(payload) {
  return request(`/iwms-wms/wms/inner/consuming/${payload.billNumber}/get?dcUuid=${loginOrg().uuid}`);
}

export async function getNtcByBillNumber(payload) {
  return request(`/iwms-wms/wms/inner/consumingntc/${payload.billNumber}/get?dcUuid=${loginOrg().uuid}`, {
    method: 'GET'
  })
}

export async function audit(payload) {
  return request(`/iwms-wms/wms/inner/consuming/${payload.uuid}/audit?version=${payload.version}`, {
    method: 'POST'
  });
}

export async function auditForInitial(payload) {
  return request(`/iwms-wms/wms/inner/consuming/audit/initial`, {
    method: 'POST',
    body: payload
  });
}

export async function save(payload) {
  return request(`/iwms-wms/wms/inner/consuming`, {
    method: 'POST',
    body: payload,
  });
}

export async function saveAndAudit(payload) {
  return request(`/iwms-wms/wms/inner/consuming/saveAndAudit`, {
    method: 'POST',
    body: payload,
  });
}

export async function modify(payload) {
  return request(`/iwms-wms/wms/inner/consuming/modify`, {
    method: 'POST',
    body: payload,
  });
}

export async function remove(payload) {
  return request(`/iwms-wms/wms/inner/consuming/${payload.uuid}?version=${payload.version}`, {
    method: 'DELETE',
  });
}

export async function queryConsumingAbleStock(payload) {
  return request(`/iwms-wms/wms/inner/consuming/queryConsumingAbleStock`, {
    method: 'POST',
    body: payload,
  });
}

export async function genInitialConsumBill(payload) {
  return request(`/iwms-wms/wms/inner/consuming/genInitialConsumBill?dcUuid=${payload.dcUuid}&consumingNtcBillNumber=${payload.consumingNtcBillNumber}`, {
    method: 'POST'
  });
}
